<template>
  <v-container>
    <v-row justify="center">
      <ViewHeader :title="viewTitle" />
      <GoogleMyBusiness
        @sort="sort($event)"
        v-if="businessAddresses.length"
        :hideTitle="true"
        :loading="loading.hoc"
        :businessAddresses="paginationChunks[page - 1]"
        :sort="$route.query.sort"
      >
        <template v-slot:pagination>
          <Pagination
            class="mb-3"
            v-if="paginationChunks.length > 1"
            :page="page"
            :per-page="perPage"
            :total-count="totalChunksCount"
            :showOptions="false"
            @change="handlePaginationChange"
          ></Pagination>
        </template>

        <template v-slot:gmbSearch>
          <v-text-field
            :hide-details="true"
            outlined
            rounded
            v-model="gmbSearch"
            @keypress.enter="search(true)"
            :label="$t('message.common.find')"
            class="mx-5"
          >
            <template v-slot:append>
              <v-btn
                @click="search(true)"
                color="primary"
                icon
                style="margin-top: -6px;"
              >
                <v-icon>
                  icon-search
                </v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </template>
      </GoogleMyBusiness>
      <SectionLoader :status="loading.view" />
    </v-row>
  </v-container>
</template>

<script>
import ViewHeader from "@/components/ui/ViewHeader";
import Pagination from "@/components/List/Pagination";
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import GoogleMyBusiness from "@/components/hoc/Visibility/GoogleMyBusiness.vue";

import businessAddressesService from "@/services/businessAddresses";
import serviceHandler from "@/helpers/handlers/service";
import { gtmEngagement as gtmEngagementMixin } from "@/helpers/mixins/gtm-engagement";

import { gtmEvent__listSearch } from "@/helpers/gtm-events";
import { chunk } from "lodash";

export default {
  name: "LocationsQuality",
  mixins: [gtmEngagementMixin],
  data() {
    return {
      loading: {
        view: false,
        hoc: false
      },
      viewTitle: this.$t("message.businessAddresses.quality.viewTitle"),
      businessAddresses: [],
      GMBbusinessAddresses: [],
      paginationChunks: [],
      gmbSearch: "",
      page: 1,
      perPage: 15
    };
  },

  computed: {
    totalChunksCount() {
      return this.paginationChunks.length * this.perPage;
    }
  },

  components: {
    ViewHeader,
    Pagination,
    SectionLoader,
    GoogleMyBusiness
  },

  async mounted() {
    this.loading.view = true;

    await this.fetchBusinessAddresses();

    this.loading.view = false;
    this.mixin__setGtmEngagementTimeouts();
  },

  methods: {
    async sort(payload) {
      this.loading.hoc = true;
      const data = await serviceHandler(
        businessAddressesService.getBusinessAddressesData(payload)
      );

      if (data.length > 0) {
        this.GMBbusinessAddresses = data;
      }

      this.search();
      this.loading.hoc = false;
    },
    search(userTriggered = false) {
      this.loading.hoc = true;
      const data = this.GMBbusinessAddresses.filter(item => {
        return (
          (item.name && item.name.toLowerCase().match(this.gmbSearch)) ||
          (item.formatted_address &&
            item.formatted_address.toLowerCase().match(this.gmbSearch))
        );
      });

      if (userTriggered) {
        gtmEvent__listSearch({
          query: this.gmbSearch,
          resultsNum: data.length,
          component: "locations_quality"
        });
      }

      this.createPaginationChunks(data, 15);
      this.page = 1;
      this.loading.hoc = false;
    },
    async fetchBusinessAddresses() {
      const data = await serviceHandler(
        businessAddressesService.getBusinessAddressesData()
      );

      if (data && data.length) {
        this.businessAddresses = data;
        this.GMBbusinessAddresses = data;
      }
    },
    createPaginationChunks(arr, size) {
      this.paginationChunks = chunk(arr, size);
    },
    handlePaginationChange({ page, perPage }) {
      this.loading.hoc = true;
      this.page = page;
      this.loading.hoc = false;
    }
  }
};
</script>
